import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { getUGCByType, getSingularUGCByUsers, getUGCByBibs, getSingularUGCForCurrentUser } from './UGCBaseSelector';

const getTransactions = state => state.getIn(['ugc', 'ratingsTransactions'], Immutable.Map());

export const getRatings = getUGCByType('ratings');
export const getRatingsByUsers = getSingularUGCByUsers('ratings');
export const getRatingsByBibs = getUGCByBibs('ratings');
export const getCurrentUserRatings = getSingularUGCForCurrentUser('ratings');
export const getRatingsTransactions = createSelector([getTransactions], (transactions) => transactions);

export default {
  getRatings,
  getRatingsByUsers,
  getRatingsByBibs,
  getCurrentUserRatings,
  getRatingsTransactions
};



// WEBPACK FOOTER //
// ./app/selectors/ugc/RatingsSelector.js